import {
  FETCH_DATA_REQUEST,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_FAILURE,
  FETCH_LIST_REQUEST,
  FETCH_LIST_SUCCESS,
  FETCH_LIST_FAILURE,
  POST_DATA_REQUEST,
  FETCH_ADMINS_REQUEST,
  FETCH_ADMINS_SUCCESS,
  FETCH_ADMINS_FAILURE,
  POST_DATA_SUCCESS,
  POST_DATA_FAILURE,
  RESET_FACILITY_DATA,
  RESET_ADMIN_DATA,
  SET_ACTIVE_MAIN_NAVLINK,
  FETCH_FACILITY_USER_REQUEST,
  FETCH_FACILITY_USER_SUCCESS,
  FETCH_FACILITY_USER_FAILURE,
  POST_FACILITY_USER_REQUEST,
  POST_FACILITY_USER_SUCCESS,
  POST_FACILITY_USER_FAILURE,
  FETCH_FACILITY_USER_DB_REQUEST,
  FETCH_FACILITY_USER_DB_SUCCESS,
  FETCH_FACILITY_USER_DB_FAILURE,
  CLEAR_FACILITY_USER,
  EDIT_DATA_REQUEST,
  EDIT_DATA_SUCCESS,
  EDIT_DATA_FAILURE,
  EDIT_FACILITY_USER_REQUEST,
  EDIT_FACILITY_USER_SUCCESS,
  EDIT_FACILITY_USER_FAILURE,
} from "../actions/actionTypes"

// Initial state
const initialState = {
  loading: false,
  data: [],
  error: "",
}

// Reducer function
export const facilitySFReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DATA_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_DATA_SUCCESS:
      return {
        loading: false,
        data: action.payload,
        error: "",
      }
    case FETCH_DATA_FAILURE:
      return {
        loading: false,
        data: [],
        error: action.payload,
      }
    case RESET_FACILITY_DATA:
      return { ...state, data: [] }

    default:
      return state
  }
}

// Reducer function
export const getFacilityDBReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_LIST_SUCCESS:
      return {
        loading: false,
        data: action.payload,
        error: "",
      }
    case FETCH_LIST_FAILURE:
      return {
        loading: false,
        data: [],
        error: action.payload,
      }
    default:
      return state
  }
}

export const adminListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADMINS_REQUEST:
      return { ...state, loading: true }
    case FETCH_ADMINS_SUCCESS:
      return { loading: false, data: action.payload, error: "" }
    case FETCH_ADMINS_FAILURE:
      return { loading: false, data: [], error: action.payload }
    case RESET_ADMIN_DATA:
      return initialState
    default:
      return state
  }
}

export const AddFacilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_DATA_REQUEST:
      return { ...state, loading: true, error: null }
    case POST_DATA_SUCCESS:
      return { ...state, loading: false, data: action.payload }
    case POST_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

//worksite
export const worksiteReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DATA_REQUEST:
      return { ...state, loading: true, error: null }
    case FETCH_DATA_SUCCESS:
      return { ...state, worksiteData: action.payload, loading: false }
    case FETCH_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        worksiteData: [],
      }
    default:
      return state
  }
}

const initialStateNav = {
  activeNavLink: "", // Default to no active NavLink
}

export const mainNavReducer = (state = initialStateNav, action) => {
  if (action.type === SET_ACTIVE_MAIN_NAVLINK) {
    return {
      ...state,
      activeNavLink: action.payload,
    }
  } else {
    return state
  }
}

export const fetchFacilityUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FACILITY_USER_REQUEST:
      return { ...state, loading: true, error: "" }
    case FETCH_FACILITY_USER_SUCCESS:
      return { ...state, loading: false, data: action.payload }
    case FETCH_FACILITY_USER_FAILURE:
      return { ...state, loading: false, error: action.payload }
    case CLEAR_FACILITY_USER:
      return { ...state, data: [] }
    default:
      return state
  }
}

const initialUserPostState = {
  loading: false,
  userId: null,
  accessData: null,
  userTypeData: null,
  error: null,
}

export const postFacilityUserReducer = (
  state = initialUserPostState,
  action,
) => {
  switch (action.type) {
    case POST_FACILITY_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case POST_FACILITY_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        userId: action.payload.userId,
        accessData: action.payload.accessData,
        userTypeData: action.payload.userTypeData,
        error: null,
      }
    case POST_FACILITY_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}

export const editFacilityUserReducer = (
  state = initialUserPostState,
  action,
) => {
  switch (action.type) {
    case EDIT_FACILITY_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case EDIT_FACILITY_USER_SUCCESS:
      // H-1: payload no longer sent (Promise.all without destructuring)
      return {
        ...state,
        loading: false,
        userId: action.payload?.userId ?? state.userId,
        accessData: action.payload?.accessData ?? state.accessData,
        userTypeData: action.payload?.userTypeData ?? state.userTypeData,
        error: null,
      }
    case EDIT_FACILITY_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}

export const facilityUserDBReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FACILITY_USER_DB_REQUEST:
      return { ...state, loading: true, error: null }
    case FETCH_FACILITY_USER_DB_SUCCESS:
      return { ...state, loading: false, data: action.payload }
    case FETCH_FACILITY_USER_DB_FAILURE:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const editFacilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_DATA_REQUEST:
      return { ...state, loading: true, error: null }
    case EDIT_DATA_SUCCESS:
      return { ...state, loading: false, facility: action.payload }
    case EDIT_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}
